import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { educationService } from '../services/education.service';
import type { Education } from '../types/education.types';

interface DeleteEducationParams {
  candidateId: string;
  educationId: string;
}

export function useDeleteEducation(): {
  deleteEducation: UseMutateFunction<Education, Error, DeleteEducationParams>;
  isLoading: boolean;
} {
  const queryClient = useQueryClient();

  const { mutate: deleteEducation, isPending: isLoading } = useMutation({
    mutationFn: ({ candidateId, educationId }: DeleteEducationParams) =>
      educationService.delete(candidateId, educationId),
    onSuccess: (_data, { candidateId }) => {
      queryClient.invalidateQueries({ queryKey: ['educations', candidateId] });
    },
  });

  return { deleteEducation, isLoading };
}
